export const calculator = (imageWidth, imageHeight, containerWidth, containerHeight) => {
    const vertexStart = {
        x: 0,
        y: 0,
    };
    const vertexEnd = {
        x: containerWidth,
        y: containerHeight,
    };
    // console.log("image width:", imageWidth)
    const widthScale = imageWidth / containerWidth;
    const heightScale = imageHeight / containerHeight;
    // 图片的 长 > 容器的 长 或者 图片的 宽 > 容器的 宽
    // if (imageWidth >= containerWidth || imageHeight >= containerHeight) {
    // 看谁的比例大
    if (widthScale > heightScale) {
        // 绘画起点 从左边 坐标为0 开始
        // 横坐标不需要变
        // 计算出纵坐标
        // 容器的高 减去 图片的高缩小后的尺寸 除以二
        // vertexStart.y = (containerHeight - imageHeight / widthScale) / 2;
        vertexStart.y = 0;
        // 算出右下角的纵坐标 因为上下等距, 所以容器高减掉上面计算出来的数就知道右下角的纵坐标
        vertexEnd.y = containerHeight - vertexStart.y;
    }
    else {
        // 容器的宽 减去 图片的宽缩小后的尺寸 除以二
        // vertexStart.x = (containerWidth - imageWidth / heightScale) / 2;
        vertexStart.x = 0;
        // 算出右下角的横坐标 因为左右等距, 所以容器高减掉上面计算出来的数就知道右下角的横坐标
        vertexEnd.x = containerWidth - vertexStart.x;
    }
    const scale = widthScale >= 1 && heightScale >= 1 ? Math.max(widthScale, heightScale) : 1;
    const rect = {
        scale,
        widthScale,
        heightScale,
        vertexes: [vertexStart, vertexEnd],
    };
    return rect;
};
export const roundDivision = (val, dividor) => {
    const res = (val / dividor).toFixed(2);
    return Number(res);
};
